import {HttpClient} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {NewsAnnouncement} from '../main/news-announcement';
import {BrandID} from '../enums/brand-id';
import {PersonLoginService} from './person-login-service';

@Service()
export class NewsAnnouncementService {
  private readonly http = inject(HttpClient);
  private readonly personLoginService = inject(PersonLoginService);


  private urlBase = environment.serviceUrl;

  public getActiveAnnouncements(brandID: BrandID): Observable<NewsAnnouncement[]> {
    let url = this.urlBase + 'newsAnnouncement/active/' + brandID;
    return this.http.get<NewsAnnouncement[]>(url);
  }

}
